import { CartState, type Cart } from '~~/types/commercetools';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~~/constants/routes';
import { isCheckoutPageSlug } from '~~/helpers/routes/getPageInformation';
import { useCheckoutQueryStore } from '~/stores/checkout/useCheckoutQueryStore';
import { useExpondoMiddleware } from '~/composables/useExpondoMiddleware';
import { toQueryString } from '~~/helpers/query/toQueryString';
import { Logger } from '~~/helpers/logger';
import { defineNuxtRouteMiddleware } from '#imports';

const isCheckoutPage = (path: string) => isCheckoutPageSlug(path);

export default defineNuxtRouteMiddleware(async (to, from) => {

  if (isCheckoutPage(to.path)) {

    return;

  }

  const checkoutQueryStore = useCheckoutQueryStore();
  const { makeCommercetoolsRequest } = useExpondoMiddleware();
  const cartState = useState<Cart | null>('useCart-cart');

  try {

    const cartIdFromToQuery = toQueryString(to.query.cartId);
    const cartIdFromFromQuery = toQueryString(from.query.cartId);
    const cartIdFromToMeta = toQueryString(to.meta.cartIdFromLink);
    const cartIdFromFromMeta = toQueryString(from.meta.cartIdFromLink);
    const cartIdFromStore = toQueryString(checkoutQueryStore.cartIdFromLink);
    const effectiveCartId = cartIdFromToQuery
      || cartIdFromFromQuery
      || cartIdFromToMeta
      || cartIdFromFromMeta
      || cartIdFromStore;

    if (!effectiveCartId) {

      return;

    }

    const response = await makeCommercetoolsRequest<{ me?: { carts?: { results?: Cart[] } } }>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_MY_FROZEN_CART,
      data: [{ cartId: effectiveCartId }, undefined],
    });

    const frozenCart = response?.data?.me?.carts?.results?.[0] || null;

    if (!frozenCart) {

      return;

    }

    if (frozenCart.cartState !== CartState.Frozen) {

      return;

    } else if (typeof frozenCart.version !== 'number') {

      Logger.warn('[clear-frozen-cart-after-checkout-exit] Found frozen cart with invalid version', {
        effectiveCartId,
      });

      return;

    }


    await makeCommercetoolsRequest({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.DELETE_CART,
      data: [{ id: frozenCart.id, version: frozenCart.version }],
    });

    cartState.value = null;
    checkoutQueryStore.setCartIdFromLink(null);

  } catch (error) {

    Logger.error('clear-frozen-cart-after-checkout-exit middleware failed', error);

  }

});
